import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex align-items-center justify-content-center text-black h-2rem mt-2 select-none"
}
const _hoisted_2 = { class: "left col-fixed p-2 bg-white" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = {
  key: 0,
  class: "right col-fixed p-2 bg-white"
}
const _hoisted_5 = ["textContent"]

import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { usePeopleStore } from '@/store';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';

/**
 * Define the people store instance and references.
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'UserHeaderTotals',
  setup(__props) {

const peopleStore = usePeopleStore();
const { totals } = storeToRefs(peopleStore);
const { getTotals } = peopleStore;

/**
 * Define a route instance.
 */
const route = useRoute();
/**
 * Initialize everything required to build out the component.
 */
onMounted(() => init());

/**
 * Only display the user totals within the user list.
 */
const showTotals = computed<boolean>(
  () =>
    (route.name === 'user.list' || route.name === 'user.referrals') &&
    can([PERMISSIONS.PEOPLE_TOTALS, PERMISSIONS.PEOPLE_INDEX_CONNECTED]),
);
const isUserMainPage = computed<boolean>(() => route.name === 'user.list');

/**
 * Define the total of people available.
 */
const total = computed<number>(() => totals.value.data.total);

/**
 * Define the total or active people.
 */
const active = computed<number>(() => totals.value.data.active);

/**
 * Initialize the people listing and the available types.
 */
const init = async () => {
  if (can([PERMISSIONS.PEOPLE_TOTALS, PERMISSIONS.PEOPLE_INDEX_CONNECTED])) await getTotals();
};

return (_ctx: any,_cache: any) => {
  return (showTotals.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mr-1 text-xs font-normal" }, "Total", -1)),
          _createElementVNode("span", {
            class: "text-sm font-bold",
            textContent: _toDisplayString(total.value)
          }, null, 8, _hoisted_3)
        ]),
        (isUserMainPage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mr-1 text-xs font-normal" }, "Active", -1)),
              _createElementVNode("span", {
                class: "text-sm font-bold",
                textContent: _toDisplayString(active.value)
              }, null, 8, _hoisted_5)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})